import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../../../../components/Header";
import Footer from "../../../../components/Footer";
import "../../styleAllServices.css";
import lawnImg from "../../../../assets/img/plantings-and-rock-landscape.jpg";
import weedImg from "../../../../assets/img/projects/plantings/side-yard-garden-bed.jpg";

export default function OrganicWeedControl() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    const canonicalUrl = `https://bur-han.ca${location.pathname}`;
    let linkTag = document.querySelector('link[rel="canonical"]');
    if (linkTag) { linkTag.setAttribute("href", canonicalUrl); }
    else {
      linkTag = document.createElement("link");
      linkTag.setAttribute("rel", "canonical");
      linkTag.setAttribute("href", canonicalUrl);
      document.head.appendChild(linkTag);
    }
    document.title = "Organic Weed Control Vancouver | Pesticide-Free Lawn Weed Management | BUR-HAN";
    const desc = "Pesticide-free organic weed control in Vancouver. BUR-HAN uses safe, effective weed management programs to keep your lawn weed-free without chemicals. Free quote: 604-983-2687";
    let metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) { metaDesc.setAttribute("content", desc); }
    else {
      metaDesc = document.createElement("meta");
      metaDesc.setAttribute("name", "description");
      metaDesc.setAttribute("content", desc);
      document.head.appendChild(metaDesc);
    }
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) { ogTitle.setAttribute("content", document.title); }
    else {
      ogTitle = document.createElement("meta");
      ogTitle.setAttribute("property", "og:title");
      ogTitle.setAttribute("content", document.title);
      document.head.appendChild(ogTitle);
    }
    let ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) { ogDesc.setAttribute("content", desc); }
    else {
      ogDesc = document.createElement("meta");
      ogDesc.setAttribute("property", "og:description");
      ogDesc.setAttribute("content", desc);
      document.head.appendChild(ogDesc);
    }
  }, [location.pathname]);
 
  return (
    <div className="wrapper">
      <Header />
      <div className="serviceItemsHeader">
        <h1 data-aos="zoom-in">Organic Weed Control Vancouver</h1>
      </div>
      <div className="serviceItemsMain">
        <h2 data-aos="fade-down">
          "A weed-free lawn without chemicals — safe for your family and the environment."
        </h2>
        <hr />
        <section className="section-container">
          <div className="image-container px-5" data-aos="fade-right">
            <img loading="lazy" src={weedImg}
              alt="Organic lawn treatment being applied to a Vancouver residential lawn"
              title="Organic Weed Control Application in Vancouver"
            />
          </div>
          <div className="text-container px-5" data-aos="fade-up">
            <h3 className="headingImageText text-uppercase">Pesticide-Free Weed Management</h3>
            <p>
              BC law prohibits the use of cosmetic pesticides for weed control on residential lawns — and BUR-HAN has always been ahead of that standard. Since 1995, we've built our entire lawn care approach around organic, pesticide-free methods that are effective, safe for children and pets, and respectful of the local environment.
            </p>
            <p>
              Our organic weed control program is built on a simple principle: a thick, healthy, well-fed lawn has no room for weeds. Rather than repeatedly treating symptoms, we focus on building the conditions where grass wins.
            </p>
          </div>
        </section>
        <section className="section-container">
          <div className="text-container px-5" data-aos="fade-up">
            <h3 className="headingImageText text-uppercase">How Our Organic Weed Control Works</h3>
            <ul>
              <li><strong>Soil correction:</strong> Liming and fertilization create conditions where grass grows thick and crowds out weeds naturally.</li>
              <li><strong>Overseeding bare spots:</strong> Bare soil is an open invitation for weeds. We overseed thin areas so grass fills in before weeds can establish.</li>
              <li><strong>Mowing height management:</strong> Cutting grass at the correct height (3–3.5") shades the soil surface and suppresses weed germination.</li>
              <li><strong>Organic spot treatments:</strong> Where needed, we use approved organic treatments such as iron-based or acetic acid products.</li>
              <li><strong>Regular monitoring:</strong> Our crews flag weed pressure early during maintenance visits so problems are addressed before they spread.</li>
            </ul>
          </div>
          <div className="image-container px-5" data-aos="fade-left">
            <img loading="lazy" src={lawnImg}
              alt="Beautiful weed-free residential lawn maintained organically by BUR-HAN in Vancouver"
              title="Organic Lawn Care Results — Weed-Free Vancouver Lawn"
            />
          </div>
        </section>

        <section className="lawnCareLinks" data-aos="fade-up">
          <h2>More Residential Lawn Care Services</h2>
          <div className="lawnCareLinks-grid">
      <a href="/services/residential-lawn-care">
        <strong>Residential Lawn Care</strong>
        <span>All lawn care services</span>
      </a>
      <a href="/services/residential-lawn-care/liming">
        <strong>Lawn Liming</strong>
        <span>Soil pH correction</span>
      </a>
      <a href="/services/residential-lawn-care/moss-control">
        <strong>Moss Control</strong>
        <span>Treatment & prevention</span>
      </a>
      <a href="/services/residential-lawn-care/topdressing">
        <strong>Topdressing</strong>
        <span>Compost & soil improvement</span>
      </a>
      <a href="/services/residential-lawn-care/overseeding">
        <strong>Overseeding</strong>
        <span>Thicken & repair your lawn</span>
      </a>
          </div>
        </section>
        <div className="secondBanner">
          <div className="container" data-aos="fade-down">
            <div className="row">
              <div className="col-md-6">
                <h3>Ready to elevate your outdoor experience?</h3>
                <p>Fill out our Get a Quote page and let BUR-HAN build a pesticide-free weed management program tailored to your Vancouver lawn.</p>
              </div>
              <div className="col-md-6">
                <div className="call-to-action text-right">
                  <a href="/contact-us" className="get-a-quote">Get A Quote</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}
